import { createClient } from '@supabase/supabase-js';
import type { Database } from './database.types';

const configuredUrl = import.meta.env.VITE_SUPABASE_URL;
const configuredAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

/**
 * Non-null when this build has no usable Supabase credentials. Callers should
 * report it rather than letting requests fail against the local-dev fallback,
 * which produces connection errors that look nothing like the real problem.
 */
export const supabaseConfigError =
  !configuredUrl || !configuredAnonKey
    ? 'This build of the admin console has no Supabase credentials. VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY must be set when the app is built.'
    : null;

if (supabaseConfigError) {
  if (import.meta.env.DEV) {
    console.warn(`${supabaseConfigError} Falling back to the local Supabase stack.`);
  } else {
    console.error(supabaseConfigError);
  }
}

export const supabaseUrl = configuredUrl || 'http://localhost:54321';

export const supabase = createClient<Database>(supabaseUrl, configuredAnonKey || 'placeholder-key');

// Service client for admin operations (server-side only ideally)
const supabaseServiceKey = import.meta.env.VITE_SUPABASE_SERVICE_KEY;

export const supabaseAdmin = supabaseServiceKey
  ? createClient<Database>(supabaseUrl, supabaseServiceKey, {
      auth: {
        autoRefreshToken: false,
        persistSession: false,
      },
    })
  : supabase;
